export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('de-DE',
        { style: 'currency', currency: 'EUR' }
    ).format(amount);
}
